export const PermissionKey = {
  // Organization relationships (platform)
  ORG_RELATIONSHIPS_CREATE: 'org-relationships:create',
  ORG_RELATIONSHIPS_READ: 'org-relationships:read',
  ORG_RELATIONSHIPS_UPDATE: 'org-relationships:update',
  ORG_RELATIONSHIPS_DELETE: 'org-relationships:delete',

  // Organizations (platform)
  ORGANIZATIONS_CREATE: 'organizations:create',
  ORGANIZATIONS_READ: 'organizations:read',
  ORGANIZATIONS_UPDATE: 'organizations:update',
  ORGANIZATIONS_DELETE: 'organizations:delete',

  // ── Knowledge base (platform catalog) ─────────────────────────────
  // Seeded for SUPER_ADMIN via ALL_PERMISSION_KEYS in rbac.seed.ts.
  // Controllers live under apps/api/src/modules/knowledgeBase.

  // Asset types
  ASSET_TYPES_CREATE: 'asset-types:create',
  ASSET_TYPES_READ: 'asset-types:read',
  ASSET_TYPES_UPDATE: 'asset-types:update',
  ASSET_TYPES_DELETE: 'asset-types:delete',
  ASSET_TYPES_IMPORT: 'asset-types:import',

  // Manufacturers
  MANUFACTURERS_CREATE: 'manufacturers:create',
  MANUFACTURERS_READ: 'manufacturers:read',
  MANUFACTURERS_UPDATE: 'manufacturers:update',
  MANUFACTURERS_DELETE: 'manufacturers:delete',

  // Asset models
  ASSET_MODELS_CREATE: 'asset-models:create',
  ASSET_MODELS_READ: 'asset-models:read',
  ASSET_MODELS_UPDATE: 'asset-models:update',
  ASSET_MODELS_DELETE: 'asset-models:delete',

  // Asset type × manufacturer × model associations
  ASSET_TYPE_MANUFACTURER_MODELS_CREATE:
    'asset-type-manufacturer-models:create',
  ASSET_TYPE_MANUFACTURER_MODELS_READ: 'asset-type-manufacturer-models:read',
  ASSET_TYPE_MANUFACTURER_MODELS_UPDATE:
    'asset-type-manufacturer-models:update',
  ASSET_TYPE_MANUFACTURER_MODELS_DELETE:
    'asset-type-manufacturer-models:delete',

  // Subsystems
  SUBSYSTEMS_CREATE: 'subsystems:create',
  SUBSYSTEMS_READ: 'subsystems:read',
  SUBSYSTEMS_UPDATE: 'subsystems:update',
  SUBSYSTEMS_DELETE: 'subsystems:delete',
  SUBSYSTEMS_IMPORT: 'subsystems:import',

  // Component classes
  COMPONENT_CLASSES_CREATE: 'component-classes:create',
  COMPONENT_CLASSES_READ: 'component-classes:read',
  COMPONENT_CLASSES_UPDATE: 'component-classes:update',
  COMPONENT_CLASSES_DELETE: 'component-classes:delete',
  COMPONENT_CLASSES_IMPORT: 'component-classes:import',

  // ComponentTypes
  COMPONENT_TYPES_CREATE: 'component-types:create',
  COMPONENT_TYPES_READ: 'component-types:read',
  COMPONENT_TYPES_UPDATE: 'component-types:update',
  COMPONENT_TYPES_DELETE: 'component-types:delete',

  // Event states
  EVENT_STATES_CREATE: 'event-states:create',
  EVENT_STATES_READ: 'event-states:read',
  EVENT_STATES_UPDATE: 'event-states:update',
  EVENT_STATES_DELETE: 'event-states:delete',
  EVENT_STATES_IMPORT: 'event-states:import',

  // Parameter names
  PARAMETER_NAMES_CREATE: 'parameter-names:create',
  PARAMETER_NAMES_READ: 'parameter-names:read',
  PARAMETER_NAMES_UPDATE: 'parameter-names:update',
  PARAMETER_NAMES_DELETE: 'parameter-names:delete',
  PARAMETER_NAMES_IMPORT: 'parameter-names:import',

  // Asset type ↔ subsystem mappings
  ASSET_TYPE_SUBSYSTEMS_READ: 'asset-type-subsystems:read',
  ASSET_TYPE_SUBSYSTEMS_UPDATE: 'asset-type-subsystems:update',

  // Asset type / subsystem ↔ component class mappings
  ASSET_SUBSYSTEM_COMPONENT_CLASSES_READ:
    'asset-subsystem-component-classes:read',
  ASSET_SUBSYSTEM_COMPONENT_CLASSES_UPDATE:
    'asset-subsystem-component-classes:update',

  // Asset type / subsystem / component class ↔ component-type mappings
  ASSET_SUBSYSTEM_COMPONENT_CLASS_COMPONENT_TYPES_READ:
    'asset-subsystem-component-class-component-types:read',
  ASSET_SUBSYSTEM_COMPONENT_CLASS_COMPONENT_TYPES_UPDATE:
    'asset-subsystem-component-class-component-types:update',

  // Assets (operational)
  ASSETS_CREATE: 'assets:create',
  ASSETS_READ: 'assets:read',
  ASSETS_UPDATE: 'assets:update',
  ASSETS_DELETE: 'assets:delete',
  ASSETS_IMPORT: 'assets:import',

  // Component twins groups (operational)
  COMPONENT_TWINS_READ: 'component-twins:read',
  COMPONENT_TWINS_CREATE: 'component-twins:create',
  COMPONENT_TWINS_UPDATE: 'component-twins:update',
  COMPONENT_TWINS_DELETE: 'component-twins:delete',

  // Installed components / ComponentSchema (operational)
  COMPONENTS_READ: 'components:read',
  COMPONENTS_CREATE: 'components:create',
  COMPONENTS_UPDATE: 'components:update',
  COMPONENTS_DELETE: 'components:delete',

  // Custom fields (operational)
  CUSTOM_FIELDS_READ: 'custom-fields:read',
  CUSTOM_FIELDS_UPDATE: 'custom-fields:update',
  CUSTOM_FIELDS_DELETE: 'custom-fields:delete',

  // Incidents (operational)
  INCIDENTS_READ: 'incidents:read',
  INCIDENTS_DIAGNOSE: 'incidents:diagnose',
  INCIDENTS_INGEST: 'incidents:ingest',
  INCIDENTS_REMOTE_ACTIONS: 'incidents:remote-actions',
  INCIDENTS_ONSITE_INTERVENTIONS: 'incidents:onsite-interventions',
  INCIDENTS_TRANSITION_STATUS: 'incidents:transition-status',

  // Diagnostic rules (ADR-0039): knowledge given to the Tier 3 diagnosis.
  // Tenant rules for these keys; global rules stay SUPER_ADMIN only.
  DIAGNOSTIC_RULES_READ: 'diagnostic-rules:read',
  DIAGNOSTIC_RULES_MANAGE: 'diagnostic-rules:manage',

  // Reports (operational)
  REPORTS_INGEST: 'reports:ingest',
  REPORTS_DOWNLOAD: 'reports:download',
  REPORTS_READ: 'reports:read',
  REPORTS_DELETE: 'reports:delete',

  // Documents (operational)
  DOCUMENTS_READ: 'documents:read',
  DOCUMENTS_UPLOAD: 'documents:upload',
  DOCUMENTS_HITL_RESOLVE: 'documents:hitl-resolve',

  // Sites (operational)
  SITES_CREATE: 'sites:create',
  SITES_READ: 'sites:read',
  SITES_UPDATE: 'sites:update',
  SITES_DELETE: 'sites:delete',

  // Zones (operational)
  ZONES_CREATE: 'zones:create',
  ZONES_READ: 'zones:read',
  ZONES_UPDATE: 'zones:update',
  ZONES_DELETE: 'zones:delete',

  // Users (operational)
  USERS_CREATE: 'users:create',
  USERS_READ: 'users:read',
  USERS_UPDATE: 'users:update',
  USERS_DELETE: 'users:delete',

  // Partners / SLA (operational)
  PARTNERS_LANDLORDS_READ: 'partners:landlords:read',
  PARTNERS_LANDLORDS_MANAGE: 'partners:landlords:manage',
  PARTNERS_OEMS_READ: 'partners:oems:read',
  PARTNERS_OEMS_MANAGE: 'partners:oems:manage',
  PARTNER_MAINTENANCE_RULES_READ: 'partners:maintenance-rules:read',
  PARTNER_MAINTENANCE_RULES_MANAGE: 'partners:maintenance-rules:manage',

  // Pipeline debug (platform sandbox — seeded to SUPER_ADMIN)
  PIPELINE_DEBUG_RUN: 'pipeline-debug:run',

  // Manual log upload (supervisor sandbox)
  MANUAL_LOG_UPLOAD_UPLOAD: 'manual-log-upload:upload',
  MANUAL_LOG_UPLOAD_CLEAR: 'manual-log-upload:clear',
  MANUAL_LOG_UPLOAD_RUN: 'manual-log-upload:run',

  // Maintenance (operational — PMP and future maintenance features)
  MAINTENANCE_READ: 'maintenance:read',
  MAINTENANCE_MANAGE: 'maintenance:manage',

  // Work orders / maintenance execution (Ticket & WO Kanban)
  WORK_ORDER_READ: 'work-order:read',
  WORK_ORDER_MANAGE: 'work-order:manage',

  // RBAC management
  PERMISSIONS_READ: 'permissions:read',
  ROLES_READ: 'roles:read',
  ROLES_CREATE: 'roles:create',
  ROLES_UPDATE: 'roles:update',
  ROLES_DELETE: 'roles:delete',
  ROLES_ASSIGN_PERMISSIONS: 'roles:assign-permissions',
  USERS_ASSIGN_ROLE: 'users:assign-role',

  // Sessions (operational)
  SESSION_READ: 'session:read',
} as const;

export type PermissionKey = (typeof PermissionKey)[keyof typeof PermissionKey];

export const RBAC_MANAGEMENT_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.PERMISSIONS_READ,
  PermissionKey.ROLES_READ,
  PermissionKey.ROLES_CREATE,
  PermissionKey.ROLES_UPDATE,
  PermissionKey.ROLES_DELETE,
  PermissionKey.ROLES_ASSIGN_PERMISSIONS,
  PermissionKey.USERS_ASSIGN_ROLE,
];

export const ASSET_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.ASSETS_CREATE,
  PermissionKey.ASSETS_READ,
  PermissionKey.ASSETS_UPDATE,
  PermissionKey.ASSETS_DELETE,
  PermissionKey.ASSETS_IMPORT,
];

export const COMPONENT_TWINS_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.COMPONENT_TWINS_READ,
  PermissionKey.COMPONENT_TWINS_CREATE,
  PermissionKey.COMPONENT_TWINS_UPDATE,
  PermissionKey.COMPONENT_TWINS_DELETE,
];

export const COMPONENTS_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.COMPONENTS_READ,
  PermissionKey.COMPONENTS_CREATE,
  PermissionKey.COMPONENTS_UPDATE,
  PermissionKey.COMPONENTS_DELETE,
];

export const USER_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.USERS_CREATE,
  PermissionKey.USERS_READ,
  PermissionKey.USERS_UPDATE,
  PermissionKey.USERS_DELETE,
];

export const PARTNERS_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.PARTNERS_LANDLORDS_READ,
  PermissionKey.PARTNERS_LANDLORDS_MANAGE,
  PermissionKey.PARTNERS_OEMS_READ,
  PermissionKey.PARTNERS_OEMS_MANAGE,
  PermissionKey.PARTNER_MAINTENANCE_RULES_READ,
];

export const MANUAL_LOG_UPLOAD_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.MANUAL_LOG_UPLOAD_UPLOAD,
  PermissionKey.MANUAL_LOG_UPLOAD_CLEAR,
  PermissionKey.MANUAL_LOG_UPLOAD_RUN,
];

export const MAINTENANCE_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.MAINTENANCE_READ,
  PermissionKey.MAINTENANCE_MANAGE,
];
/**
 * Platform knowledge-base catalog permissions.
 * SUPER_ADMIN gets all via ALL_PERMISSION_KEYS. Other system roles only get
 * intentional read grants listed in packages/db/.../roles.ts (e.g.
 * ASSET_TYPE_MANUFACTURER_MODELS_READ for asset create/edit selects).
 */
export const KNOWLEDGE_BASE_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.ASSET_TYPES_CREATE,
  PermissionKey.ASSET_TYPES_READ,
  PermissionKey.ASSET_TYPES_UPDATE,
  PermissionKey.ASSET_TYPES_DELETE,
  PermissionKey.ASSET_TYPES_IMPORT,
  PermissionKey.MANUFACTURERS_CREATE,
  PermissionKey.MANUFACTURERS_READ,
  PermissionKey.MANUFACTURERS_UPDATE,
  PermissionKey.MANUFACTURERS_DELETE,
  PermissionKey.ASSET_MODELS_CREATE,
  PermissionKey.ASSET_MODELS_READ,
  PermissionKey.ASSET_MODELS_UPDATE,
  PermissionKey.ASSET_MODELS_DELETE,
  PermissionKey.ASSET_TYPE_MANUFACTURER_MODELS_CREATE,
  PermissionKey.ASSET_TYPE_MANUFACTURER_MODELS_READ,
  PermissionKey.ASSET_TYPE_MANUFACTURER_MODELS_UPDATE,
  PermissionKey.ASSET_TYPE_MANUFACTURER_MODELS_DELETE,
  PermissionKey.SUBSYSTEMS_CREATE,
  PermissionKey.SUBSYSTEMS_READ,
  PermissionKey.SUBSYSTEMS_UPDATE,
  PermissionKey.SUBSYSTEMS_DELETE,
  PermissionKey.SUBSYSTEMS_IMPORT,
  PermissionKey.COMPONENT_CLASSES_CREATE,
  PermissionKey.COMPONENT_CLASSES_READ,
  PermissionKey.COMPONENT_CLASSES_UPDATE,
  PermissionKey.COMPONENT_CLASSES_DELETE,
  PermissionKey.COMPONENT_CLASSES_IMPORT,
  PermissionKey.COMPONENT_TYPES_CREATE,
  PermissionKey.COMPONENT_TYPES_READ,
  PermissionKey.COMPONENT_TYPES_UPDATE,
  PermissionKey.COMPONENT_TYPES_DELETE,
  PermissionKey.EVENT_STATES_CREATE,
  PermissionKey.EVENT_STATES_READ,
  PermissionKey.EVENT_STATES_UPDATE,
  PermissionKey.EVENT_STATES_DELETE,
  PermissionKey.EVENT_STATES_IMPORT,
  PermissionKey.PARAMETER_NAMES_CREATE,
  PermissionKey.PARAMETER_NAMES_READ,
  PermissionKey.PARAMETER_NAMES_UPDATE,
  PermissionKey.PARAMETER_NAMES_DELETE,
  PermissionKey.PARAMETER_NAMES_IMPORT,
  PermissionKey.ASSET_TYPE_SUBSYSTEMS_READ,
  PermissionKey.ASSET_TYPE_SUBSYSTEMS_UPDATE,
  PermissionKey.ASSET_SUBSYSTEM_COMPONENT_CLASSES_READ,
  PermissionKey.ASSET_SUBSYSTEM_COMPONENT_CLASSES_UPDATE,
  PermissionKey.ASSET_SUBSYSTEM_COMPONENT_CLASS_COMPONENT_TYPES_READ,
  PermissionKey.ASSET_SUBSYSTEM_COMPONENT_CLASS_COMPONENT_TYPES_UPDATE,
];

/**
 * Diagnostic rules (ADR-0039). Granted to no system role but SUPER_ADMIN by
 * default: tenant admins grant them through custom roles in the Roles page.
 */
export const DIAGNOSTIC_RULES_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.DIAGNOSTIC_RULES_READ,
  PermissionKey.DIAGNOSTIC_RULES_MANAGE,
];

export const WORK_ORDER_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.WORK_ORDER_READ,
  PermissionKey.WORK_ORDER_MANAGE,
];

export const SESSION_PERMISSION_KEYS: readonly PermissionKey[] = [
  PermissionKey.SESSION_READ,
];

export const ALL_PERMISSION_KEYS: readonly PermissionKey[] =
  Object.values(PermissionKey);

const PERMISSION_KEY_SET: ReadonlySet<string> = new Set(ALL_PERMISSION_KEYS);

const RBAC_MANAGEMENT_PERMISSION_KEY_SET: ReadonlySet<PermissionKey> = new Set(
  RBAC_MANAGEMENT_PERMISSION_KEYS,
);

export function isPermissionKey(value: string): value is PermissionKey {
  return PERMISSION_KEY_SET.has(value);
}

export function isRbacManagementPermissionKey(key: PermissionKey): boolean {
  return RBAC_MANAGEMENT_PERMISSION_KEY_SET.has(key);
}

export function parsePermissionKeys(values: string[]): PermissionKey[] {
  return values.filter(isPermissionKey);
}
